var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar-item"},[_c('router-link',{staticClass:"p-2",attrs:{"to":_vm.url}},[_c('div',{staticClass:"flex items-center navbar-item__link-content"},[_c('div',{staticClass:"whitespace-no-wrap navbar-item__link-name"},[_vm._v(_vm._s(_vm.name))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }